<template>
  <v-card elevation="0" class="mb-6 operations-filters">
    <div class="filter traceId">
      <p class="dialog-select-label my-0">TraceID</p>
      <v-text-field
        :value="traceId"
        class="bh-input-pill rounded-pill"
        color="accent"
        height="48px"
        placeholder="TraceID"
        filled
        clearable
        hide-details
        @input="onInput('traceId', $event)"
        @click:clear="clearSearch"
        @click:append="runSearch"
        @keydown.enter="runSearch"
      ></v-text-field>
    </div>
    <div class="filter email">
      <p class="dialog-select-label my-0">E-mail</p>
      <v-text-field
        :value="email"
        class="bh-input-pill rounded-pill"
        color="accent"
        height="48px"
        placeholder="E-mail"
        filled
        clearable
        hide-details
        @input="onInput('email', $event)"
        @click:clear="clearSearch"
        @click:append="runSearch"
        @keydown.enter="runSearch"
      ></v-text-field>
    </div>
    <div class="filter operation">
      <dialog-select
        name="operation"
        :items="operationsValues"
        :value="operation"
        label="Operation"
        placeholder="Operation"
        customClass="filter"
        itemText="label"
        itemValue="value"
        :clearable="true"
        @input="onInput('operation', $event.value)"
      />
    </div>
    <div class="filter type">
      <dialog-select
        name="type"
        :items="typesValues"
        :value="type"
        label="Type"
        placeholder="Type"
        customClass="filter"
        itemText="label"
        itemValue="value"
        :clearable="true"
        @input="onInput('type', $event.value)"
      />
    </div>
    <div class="filter range">
      <p class="dialog-select-label my-0">Date</p>
      <date-range-calendars-picker
        :mode="'select'"
        :initialEndDate="selectedRange.endDate"
        :initialStartDate="selectedRange.startDate"
        :limitSelectedDays="365"
        @select-range="selectedDate"
      />
    </div>
  </v-card>
</template>
<script>
import { debounce } from '@/helpers/debounce'
import DateRangeCalendarsPicker from '@/components/inputs/DateRangeCalendarsPicker.vue'
import DialogSelect from '@/components/forms/DialogSelect'
export default {
  name: 'OperationsFilters',
  components: {
    DialogSelect,
    DateRangeCalendarsPicker,
  },
  props: {
    traceId: {
      type: String,
      default: '',
    },
    operation: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    from: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    operations: {
      type: Object,
      default: () => {},
    },
    types: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    selectedRange: {},
    selectedValues: {},
  }),
  computed: {
    operationsValues() {
      return Object.values(this.operations).map(el => ({
        label: el,
        value: el,
      }))
    },
    typesValues() {
      return Object.values(this.types).map(el => ({
        label: el,
        value: el,
      }))
    },
    today() {
      return new Date()
    },
    lastMonth() {
      return this.$moment(this.today)
        .subtract(30, 'days')
        .toDate()
    },
  },
  methods: {
    clearSearch(key) {
      this.selectedValues[key] = ''
    },
    runSearch(key, value) {
      if (key) {
        this.selectedValues[key] = value || ''
      }

      let to = '',
        from = ''

      if (this.selectedRange.startDate)
        from = this.$moment(this.selectedRange.startDate)
          .startOf('day')
          .toISOString()
      if (this.selectedRange.endDate)
        to = this.$moment(this.selectedRange.endDate)
          .endOf('day')
          .toISOString()

      this.$emit('search-run', { ...this.selectedValues, to, from })
    },
    onInput(key, value) {
      this.selectedValues[key] = value || ''
      debounce(
        () => {
          this.runSearch()
        },
        1000,
        'OperationsFilters',
      )
    },
    selectedDate(range) {
      this.selectedRange.startDate = range.startDate
      this.selectedRange.endDate = range.endDate

      this.runSearch()
    },
  },
  created() {
    const from = this.$route?.query?.from || this.$props?.from || ''
    const to = this.$route?.query?.to || this.$props?.to || ''
    if (from && to) {
      const startDate = this.$moment(from).toDate()
      const endDate = this.$moment(to).toDate()
      this.selectedRange = {
        startDate: startDate,
        endDate: endDate,
      }
    } else if (to) {
      const endDate = this.$moment(to).toDate()
      const startDate = this.$moment(to)
        .subtract(30, 'day')
        .toDate()
      this.selectedRange = {
        startDate: startDate,
        endDate: endDate,
      }
    } else if (from) {
      const endDate = this.today
      const startDate = this.$moment(from)
        .subtract(30, 'day')
        .toDate()
      this.selectedRange = {
        startDate: startDate,
        endDate: endDate,
      }
    } else {
      this.selectedRange = {
        startDate: this.lastMonth,
        endDate: this.today,
      }
    }
  },
  watch: {
    $route(newRoute, _) {
      if (newRoute.query?.from && newRoute.query.from !== this.from) {
        this.from = newRoute.query.from
      }
      if (newRoute.query?.to && newRoute.query.to !== this.to) {
        this.to = newRoute.query.to
      }
    },
  },
}
</script>
<style lang="scss">
.operations-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-grow: 1;
  padding: $gutter * 0.5;

  .dialog-select {
    align-self: flex-end;
    width: 200px;
  }

  > .filter {
    padding: $gutter * 0.5;

    > p {
      margin-left: 8px;
    }

    &.range {
      margin-top: $gutter * 0.5;
    }
  }
}
.bh-input-pill {
  // margin: 0 8px !important;
  width: 264px;
  height: 48px !important;
  flex-grow: 0;
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;
    background: $bh-gray--6 !important;
    &::before,
    &::after {
      content: '';
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
